import { ResourceHeaders } from '..'
import {
  AddressHeader,
  DateHeader,
  IdHeader,
  InspectionProgressHeader,
  InspectionQualificationHeader,
  InspectionStatusHeader,
  InspectionSummary,
  PersonHeader,
  VehicleHeader,
  WhatsappHeader,
} from '../../headers'
import { Helpers } from '../../helpers'
import { Lead } from '@/entities/crm'
import { Process } from '@/entities/settings'
import { Inspection } from '@/entities/purchase'

export const headers: ResourceHeaders = [
  { ...IdHeader, text: 'Nº', value: '@' },
  { ...VehicleHeader, text: 'Vehiculo', value: 'appraisal.deal.auto' },
  { ...AddressHeader, text: 'Ubicación', value: 'address' },
  {
    ...PersonHeader,
    text: 'Cliente',
    value: '@',
    options: {
      path: 'appraisal.deal.lead.client.name',
      trigger: Helpers.linkedModel,
      action: {
        always: true,
        color: 'green',
        icon: 'mdi-whatsapp',
        messaging: true,
        trigger: (item: Lead, process: Process, system: string) => Helpers.contact(item, 'client', process, system),
      },
      disabledMissingProperty: ['phone'],
    },
  },
  { ...DateHeader, text: 'Fecha Agendada', value: 'scheduled' },
  { ...DateHeader, text: 'Fecha Inicio', value: 'dateFormatted' },
  { ...InspectionStatusHeader, text: 'Estado', value: 'inspectionStatus' },
  { ...InspectionProgressHeader, text: 'Progreso', value: '@' },
  {
    ...WhatsappHeader,
    text: 'Inspector',
    value: 'inspector',
    options: {
      action: {
        color: 'primary',
        always: true,
        icon: 'mdi-whatsapp',
        only: true,
        trigger: (item: Inspection, process: Process, system: string) => Helpers.contact(item, 'inspector', process, system),
      },
      disabledMissingProperty: ['phone'],
    },
  },
  {
    ...WhatsappHeader,
    text: 'Supervisor',
    value: 'supervisor',
    options: {
      action: {
        color: 'yellow',
        always: true,
        icon: 'mdi-whatsapp',
        only: true,
        trigger: (item: Inspection, process: Process, system: string) => Helpers.contact(item, 'supervisor', process, system),
      },
    },
  },
  {
    ...InspectionSummary,
    text: 'Reporte',
    value: '@',
    options: {
      tooltip: 'Reporte',
      action: {
        color: 'purple',
        icon: 'mdi-clipboard-text-search-outline',
        only: true,
      },
    },
  },
  { ...InspectionQualificationHeader, text: 'Calificación', value: 'qualification' },
]

export default function (): ResourceHeaders {
  return headers
}
